import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA } from './utils/analytics';

// Initialize Google Analytics if tracking ID is provided
if (process.env.REACT_APP_GA_TRACKING_ID) {
  initGA(process.env.REACT_APP_GA_TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Report web vitals
// In production, you can send this to an analytics endpoint
if (process.env.NODE_ENV === 'production') {
  reportWebVitals((metric) => {
    // Send to analytics service
    if (window.gtag) {
      window.gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_category: 'Web Vitals',
        event_label: metric.id,
        non_interaction: true,
      });
    }
  });
} else {
  // Log in development
  reportWebVitals(console.log);
}
